import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';

import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj, cenversionTpCode } from 'lib/commonLib';
import { localMediaReport } from 'lib/api/localreport';

import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewButton from 'components/molecules/NewButton';

const MediaStatistics = ({ location }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isPopPage = queryString.parse(location.search).isPop === '1';
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    pltfomTpCode: 'all',
    itlTpCode: 'all',
    sumSub: 1,
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };
  const [params, setParams] = useState(initParams);
  const [initialization, setInitialization] = useState(false);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = {
      url: url,
      cnt: popIndex,
    };

    dispatch(setPortal(newPortal));
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    CORP_NAME: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CORP_NAME');
        return rowObj['CORP_NAME'] !== 'total' && !rowObj['isChild'] ? (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['CORP_NAME'],
              bodyItem1.type,
              bodyItem1.format
            )}
          >
            <NewButton
              title={t('사이트로 이동')}
              iconBtn
              icon="faHome"
              onClick={(e) => handlePortalUrl('http://' + rowObj['URL'])}
            />
          </IconAreaWrap>
        ) : rowObj['CORP_NAME'] === 'total' ? (
          rowObj['CORP_NAME']
        ) : (
          cenversionTpCode(rowObj['PLTFOM_TP_CODE'])
        );
      },
    },
    MEDIA_ID: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'MEDIA_ID');
        return (
          rowObj['CORP_NAME'] !== 'total' &&
          !rowObj['isChild'] &&
          makeRowColumn(rowObj['MEDIA_ID'], bodyItem1.type, bodyItem1.format)
        );
      },
    },
    MEDIA_SCRIPT_CNT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'MEDIA_SCRIPT_CNT');
        return (
          rowObj['CORP_NAME'] !== 'total' &&
          !rowObj['isChild'] &&
          makeRowColumn(
            rowObj['MEDIA_SCRIPT_CNT'],
            bodyItem1.type,
            bodyItem1.format
          )
        );
      },
    },
    URL: { merged: true },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
      if (isPopPage && window.location.search !== '?isPop=1') {
        window.location.replace(window.location.pathname + '?isPop=1');
      }
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={localMediaReport}
        customized={customized}
        expandTable
        useFetch={false}
      />
    </>
  );
};

export default withRouter(MediaStatistics);
